module.exports = __webpack_public_path__ + "static/media/BannerV2.f83f3511.png";